import React, { Fragment, useRef } from 'react';
import { useIntl } from 'react-intl';

import { ICONS } from '../../../../consts/consts';
import ScrollableUncontrolledPopover from '../../ScrollableUncontrolledPopover';
import {
  getONACellListHeader,
  getONACellListHelperText,
  groupONAByType,
  TeamDashboardPerson,
} from './common';
import ONAList from './ONAList';

type Props = {
  person: TeamDashboardPerson;
  uniqueId: string;
};

const HeadsUpCell: React.FC<Props> = ({ person, uniqueId }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const targetRef = useRef<HTMLSpanElement>(null);

  const groupedONA = groupONAByType(person.headsups?.[1] ?? [], formatMessage);

  return (
    <>
      <span ref={targetRef} id={'row-heads-ups-' + uniqueId}>
        <i className={ICONS.HEADS_UP} />
        &nbsp;
        {person.headsups_count}
      </span>
      {person.headsups_count > 0 && (
        <ScrollableUncontrolledPopover
          placement="left"
          trigger="hover"
          target={targetRef}
        >
          {groupedONA.map(([onaSourceType, onaList], index) => {
            return (
              <Fragment key={`heads-up-ona-list-item-${onaSourceType}`}>
                {index > 0 && <hr></hr>}
                <ONAList
                  iconClassName={ICONS.HEADS_UP}
                  header={getONACellListHeader(onaSourceType, intl)}
                  onaList={onaList}
                  helperText={getONACellListHelperText(onaSourceType)}
                />
              </Fragment>
            );
          })}
        </ScrollableUncontrolledPopover>
      )}
    </>
  );
};

export default HeadsUpCell;
